export const getAbsolutePath = (path, origin) =>
  path[0] === '/' ? `${origin || window.location.origin}${path}` : path

export const forceHttps = path => path.replace('http://', 'https://')

export default { getAbsolutePath, forceHttps }
